module.exports = __webpack_public_path__ + "static/media/02A.3f79537c.png";